import React from "react";
import styled, { keyframes, ThemeProvider } from "styled-components";
import TradingHistory from "../../pages/trading-history";
import CloseIcon from "../Icons/Close";

const themes = {
  darkPopup: {
    isHistoryPopup: true,
    historyPopupTitle: true,
    closeButtonColor: "#ffffff",
    money: "#ffffff",
    statisticTitle: "rgba(255, 255, 255, 0.62)",
    paginationTitle: "#ffffff",
    tableRowHover: "rgba(255, 255, 255, 0.75)",
    supportHover: "#8fcc00",
    tableBefore: "#737373",
    tableCellColor: "rgba(255, 255, 255, 0.58) !important",
    tableCellBorder: "#484848",
    calendarTitle: "rgba(255, 255, 255, 0.62)",
    paginationActiveBorder: "#666666",
    paginationActiveColor: "#ffffff",
    paginationActiveHoverBackground: "rgba(255,255,255,0.2)",
    loaderBackground: "transparent",
    scrollbarColor: "rgba(255, 255, 255, 0.5)",
    calendarContainerBackground: true,
    popupBackground: true,
    calendarBackground: true,
    calendarInputColor: "rgba(255, 255, 255, 0.58)",
    tableRowEven: true,
    tableRowOdd: true,
    tablePaginationHover: "#ffffff"
  },
  whitePopup: {
    isHistoryPopup: true,
    historyPopupTitle: true,
    closeButtonColor: "#272B34",
    scrollbarColor: "rgba(0, 0, 0, 0.5)"
  }
};

const bottomAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(1000px);
  }
  80% {
    opacity: 0.5;
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
`;

const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 90%;
  background-color: ${({ theme }) =>
    theme.popupBackground ? theme.mainLight : "#ffffff"};
  animation: ${bottomAnimation} 0.3s ease-out;
`;

const CloseButton = styled.button`
  position: absolute;
  z-index: 2;
  right: 20px;
  top: 20px;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
  color: ${({ theme }) => theme.closeButtonColor};
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: all 150ms;
  opacity: 0.5;

  &:hover {
    opacity: 1;
    transform: rotate(90deg);
  }
`;

const HistoryContainer = styled.div`
  max-height: 100%;
  height: 100%;
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    flex: 1;
    left: 10px;
    margin-left: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    opacity: 0.75;
    border-radius: 4px;
  }
`;

const HistoryPopup = ({ themeName, onClose }) => (
  <ThemeProvider theme={themes[themeName]}>
    <Wrapper>
      <Background onClick={onClose} />
      <Container>
        <CloseButton type="button" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
        <HistoryContainer>
          <TradingHistory type="widget" />
        </HistoryContainer>
      </Container>
    </Wrapper>
  </ThemeProvider>
);

export default HistoryPopup;



// WEBPACK FOOTER //
// ./src/components/HistoryPopup/HistoryPopup.js